export const MODIFIER_TOGGLE = 'MODIFIER_TOGGLE'
export const FEATURE_SELECT = 'FEATURE_SELECT'
export const COMPARE_ADD = 'COMPARE_ADD'
export const COMPARE_REMOVE = 'COMPARE_REMOVE'
export const SHOW_TECH_DATA = 'SHOW_TECH_DATA'
export const HIDE_TECH_DATA = 'HIDE_TECH_DATA'
export const OPEN_FEATURE_SELECT = 'OPEN_FEATURE_SELECT'
export const CLOSE_FEATURE_SELECT = 'CLOSE_FEATURE_SELECT'
